module.exports = __webpack_public_path__ + "static/img/logo.bb8f178c.svg";